export const reorderBySelection = (list: Array<any>) => {
  const orderedResult = list.filter(d => d.isSelected).concat(list.filter(d => !d.isSelected));

  return orderedResult;
};
